import api from './api';

// ============================================================================
// SHARED OUTPUT CHANNEL TYPES & API
// Used by Routines and dynamic analysis job configuration.
// ============================================================================

export interface OutputChannelConfig {
  source: 'notification_channel';
  id: string;
}

export interface OutputChannelOption {
  source: 'notification_channel';
  id: string;
  type: string;
  label: string;
  detail?: string;
}

export const outputChannelsApi = {
  async getOutputChannels(): Promise<{ channels: OutputChannelOption[] }> {
    const response = await api.get('/api/output-channels');
    return { channels: response.data.data || [] };
  },
};

export default outputChannelsApi;
